import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static values = { minBudgetThreshold: Number }
  static targets = ["phoneSharingRadioButton",
                    "budgetTypeSelect",
                    "globalBudgetInput",
                    "budgetPerPersonInput",
                    "guestsInput",
                    "isAgencyInput"]

  phoneSharingUpdator () {
    this.phoneSharingNoButton.disabled = this.isHighBudget && !this.isAgencyInput
    this.phoneSharingYesButton.disabled = this.isAgencyInput
    this.phoneSharingYesButton.checked = this.isHighBudget && !this.isAgencyInput
    this.phoneSharingNoButton.checked = !this.isHighBudget || this.isAgencyInput
  }

  get globalBudget () {
    if (this.isGlobalBudget) {
      return parseFloat(this.globalBudgetInputTarget.value) || 0
    }

    const budgetPerPerson = parseFloat(this.budgetPerPersonInputTarget.value) || 0
    const guests = parseFloat(this.guestsInputTarget.value) || 0

    return budgetPerPerson * guests
  }

  get isGlobalBudget () {
    return this.budgetTypeSelectTarget.value == "budget_global"
  }

  get isAgencyInput () {
    return this.isAgencyInputTarget.value === "true"
  }

  get phoneSharingYesButton () {
    return this.phoneSharingRadioButtonTargets.find((input) => input.value === "true")
  }

  get phoneSharingNoButton () {
    return this.phoneSharingRadioButtonTargets.find((input) => input.value === "false")
  }

  get isHighBudget () {
    return this.globalBudget >= this.minBudgetThresholdValue
  }
}
